import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import withBackSupport from 'components/HOCs/withBackSupport';
import withMenu from 'components/HOCs/withMenu';
import withScrollHack from 'components/HOCs/withScrollHack';
import useLeaveFor from 'hooks/useLeaveFor';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';
import { selectWatchlist } from 'reducers/watchlist/selectors';
import {
  fetchWatchlist,
  loadExtraWatchlistItems,
  resetAllWatchlistData,
  removeItem,
} from 'actions/watchlist';
import NotLoggtedStub from './NotLoggedStub';
import WatchlistPage from './Page';

const WatchlistContainer = (props) => {
  const { isLoggedIn, resetAllWatchlistData, ...rest } = props;
  const history = useHistory();

  useLeaveFor(history, (location) => {
    // It clears all data, because all data could be changed outside player
    if (!location.pathname.startsWith('/player')) resetAllWatchlistData();
  });

  return isLoggedIn ? <WatchlistPage {...rest} /> : <NotLoggtedStub />;
};

const mapStateToProps = createStructuredSelector({
  isLoggedIn: getIsLoggedInSelector,
  items: selectWatchlist,
});

export const mapDispatchToProps = {
  fetchWatchlist,
  loadExtraWatchlistItems,
  resetAllWatchlistData,
  removeItem,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withBackSupport,
  withMenu,
  withScrollHack,
)(WatchlistContainer);
